import { SilverbackPageContext } from '@amazeelabs/gatsby-source-silverback';
import { Route } from '@caritas/ui';
import { ComponentProps } from 'react';

import { languageFallback } from '../utils/localizations';
import { useTranslationMessages } from './Translations';

export const useTranslations = (
  pageContext: SilverbackPageContext,
): ComponentProps<typeof Route>['intl'] => {
  const defaultLocale = 'de';
  const messages = useTranslationMessages();
  type locale = 'de' | 'en' | 'fr' | 'it';

  return {
    defaultLocale,
    locale: pageContext.locale || defaultLocale,
    messages: (
      messages[languageFallback(pageContext.locale || 'de') as locale] ||
      messages['en']
    )
      ?.map((msg) => ({ [msg.id]: msg.message }))
      .reduce((acc, val) => ({ ...acc, ...val }), {}),
  };
};
